import { IResponseHeaderView } from 'v2/resources/types/headerView';

export const DEFAULT_RESPONSE_HEADER_VIEW: IResponseHeaderView = {
  biomass: 0,
  consumption: 0,
  fca: 0,
  survival_total: 0,
};
